import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import "../HelpandSupport/TechSupport.css";
import { getUserById, sendSupport } from "../api/api";
import { useNavigate } from "react-router-dom";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  subject: Yup.string().required("Subject is required"),
  issue: Yup.string().required("Issue description is required"),
});

const TechSupport = () => {
  const [userdata, setUserdata] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const getUserdata = async () => {
      try {
        const userData = JSON.parse(localStorage.getItem("currentUser"));
        const _id = userData?.id || userData?._id;
        if (_id) {
          const currentUser = await getUserById({ user_id: _id });
          setUserdata(currentUser);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    getUserdata();
  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: userdata?.data?.name || "",
      email: userdata?.data?.email || "",
      subject: "",
      issue: "",
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      setIsLoading(true);
      try {
        const userData = JSON.parse(localStorage.getItem("currentUser"));
        const _id = userData?.id || userData?._id;

        const requestData = {
          user_id: _id,
          name: userdata?.data?.name,
          email: userdata?.data?.email,
          message: values.issue,
          subject: "ts",
          title: values.subject,
        };
        console.log("1111111111", requestData);
        const response = await sendSupport(requestData);

        if (response?.success) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: response.message,
            confirmButtonColor: "#e04a48",
          }).then(() => {
            resetForm();
            navigate("/Sidebar/helpandsupport");
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response?.message || "Something went wrong",
            confirmButtonColor: "#e04a48",
          });
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to submit request. Please try again later.",
          confirmButtonColor: "#e04a48",
        });
      } finally {
        setIsLoading(false);
      }
    },
  });

  return (
    <div className="form-container">
      <h2>Technical Support Form</h2>
      <form onSubmit={formik.handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          value={formik.values.name}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          disabled
        />
        {formik.touched.name && formik.errors.name && (
          <div className="error">{formik.errors.name}</div>
        )}

        <input
          type="email"
          name="email"
          placeholder="Your Email"
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          disabled
        />
        {formik.touched.email && formik.errors.email && (
          <div className="error">{formik.errors.email}</div>
        )}

        <input
          type="text"
          name="subject"
          placeholder="Subject"
          value={formik.values.subject}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        {formik.touched.subject && formik.errors.subject && (
          <div className="error">{formik.errors.subject}</div>
        )}

        <textarea
          name="issue"
          placeholder="Describe Your Issue"
          rows="6"
          value={formik.values.issue}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        {formik.touched.issue && formik.errors.issue && (
          <div className="error">{formik.errors.issue}</div>
        )}

        <button type="submit" disabled={isLoading}>
          {isLoading ? "Submitting..." : "Submit Request"}
        </button>
      </form>
    </div>
  );
};

export default TechSupport;
